import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from '../store';
import messages from './langs';

Vue.use(VueI18n);

// 自动设置语言
let lang;
if (!store.state.lang) {
  let navLang = navigator.language; // 判断除IE外其他浏览器使用语言
  if (!navLang) {
    // 判断IE浏览器使用语言
    navLang = navigator.browserLanguage;
  }
  lang = navLang === 'zh-CN' ? 'cn' : 'en';
  store.commit('updateLang', lang);
}

const i18n = new VueI18n({
  locale: store.state.lang || lang,
  messages,
});

export default i18n;
